import React from 'react';
import { Link } from '@naf-simba/elements-links';

import { useDocumentUrlWithNode } from '../../../../hooks/Documents/useDocumentUrl';
import { LinkType } from '../../../../../../types/LinkType';

// Move LinkField outside to prevent recreation on every render
export const LinkField = ({ link, onClick }: { link: LinkType; onClick?: () => void }) => {
  const target = useDocumentUrlWithNode(link?.internalReference);

  switch (link?.targetType) {
    case 'internalReference':
      if (link?.internalReference) {
        return <Link to={target} text={link?.title} onClick={onClick} />;
      }
      return null;

    case 'externalTarget':
      if (link?.externalTarget?.href) {
        return (
          <Link
            href={link?.externalTarget?.href}
            target={link?.externalTarget?.blank ? '_blank' : undefined}
            rel={link?.externalTarget?.blank ? 'noopener noreferrer' : undefined}
            text={link?.title}
            onClick={onClick}
          />
        );
      }
      return null;

    default:
      return null;
  }
};
